import store from '@state/store'

export default [
  {
    path: '/signup',
    component: () => lazyLoadView(import(/* webpackChunkName: "signup" */'@views/signup-wrapper.vue')),
    children: [
      {
        component: () => lazyLoadView(import(/* webpackChunkName: "signup" */'@views/signup.vue')),
        path: '',
        name: 'signup',
        meta: {
          async beforeResolve (routeTo, routeFrom, next) {
            // case one (redirection from another route)
            if (store.getters['auth/hasFetched']) {
              return store.getters['auth/loggedIn']
                ? next({ name: 'dashboard' })
                : next()
            }
            // case two: first access to SPA
            const currentUser = await store.dispatch('auth/userShow')

              if (currentUser) {
                return next({ name: 'dashboard' })
              }
              return next()
          },
        },
      },
      {
      component: () => lazyLoadView(import(/* webpackChunkName: "register" */'@views/register.vue')),
      path: 'verify/:token',
      name: 'verify',
      meta: {
        async beforeResolve (routeTo, routeFrom, next) {
          const { params: { token } } = routeTo

          if (!token) {
            return next({ name: 'signup' })
          }

          try {
            await store.dispatch('auth/signUpVerification', { token })
            return next()
          } catch (err) {
            return next({ name: 'signup' })
          }
        },
      },
    }],
  },
  {
    path: '/thank-you',
    name: 'thank-you',
    component: () => lazyLoadView(import(/* webpackChunkName: "thank-you" */'@views/thank-you.vue')),
    meta: {
      beforeResolve (routeTo, routeFrom, next) {
        const { name } = routeFrom

        if (!store.getters['auth/currentStatus']) {
          return next({ name: 'signup' })
        }
        const { success } = store.getters['auth/currentStatus']
        if (name === 'signup' && success) {
          return next()
        }
        return next({ name: 'signup' })
      },
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import(/* webpackChunkName: "login" */'@views/login.vue')),
    meta: {
      async beforeResolve (routeTo, routeFrom, next) {
        // case one (redirection from another route)
        if (store.getters['auth/hasFetched']) {
          return store.getters['auth/loggedIn']
            ? next({ name: 'dashboard' })
            : next()
        }
        // case two: first access to SPA
        const currentUser = await store.dispatch('auth/userShow')

          if (currentUser) {
            return next({ name: 'dashboard' })
          }
          return next()
      },
    },
  },
  {
    path: '/new-reporting-form',
    name: 'new-reporting-form',
    component: () => lazyLoadView(import(/* webpackChunkName: "reporting-form" */'@views/new-reporting-form.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reporting-form-detail',
    name: 'reporting-form-detail',
    component: () => lazyLoadView(import(/* webpackChunkName: "reporting-form-detail" */'@views/reporting-form-detail.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => lazyLoadView(import(/* webpackChunkName: "reports" */'@views/reports.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/report-abuse/:abuseId',
    name: 'report-abuse',
    component: () => lazyLoadView(import(/* webpackChunkName: "reports" */'@views/update-reporting-form.vue')),
    meta: {
      authRequired: true,
      async beforeResolve (routeTo, routeFrom, next) {
        const {
          name,
        } = routeFrom

        const {
          params: { abuseId },
        } = routeTo

        if (name === 'reports') {
          const abuse = store.getters['abuse/selectedAbuse']
          routeTo.params.abuseId = abuse.id
          return next()
        }

        // here we should dispatch action for getting all abuses list
        const abuse = await store.dispatch('abuse/showAbuse', { id: abuseId })

        if (abuse) {
            routeTo.params.abuseId = abuseId
            return next()
        }
        return next({ name: '404', params: { resource: 'abuseId' } })
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import(/* webpackChunkName: "profile" */'@views/profile.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => lazyLoadView(import(/* webpackChunkName: "dashboard" */'@views/dashboard.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/all-verifications',
    name: 'all-verifications',
    component: () => lazyLoadView(import(/* webpackChunkName: "verifications" */ '@views/all-verifications.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/single-verification',
    name: 'single-verification',
    component: () => lazyLoadView(import(/* webpackChunkName: "single-verifications" */ '@views/single-verification.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/verification/:walletAddress',
    name: 'verification',
    component: () => lazyLoadView(import(/* webpackChunkName: "single-verifications-address" */'@views/single-verification.vue')),
    meta: {
      authRequired: true,
      async beforeResolve (routeTo, routeFrom, next) {
        const {
          name,
        } = routeFrom

        const {
          params: { walletAddress },
        } = routeTo

        if (name === 'new-verification') {
          const walletAddress = store.getters['report/currentReportAddressWallet']
          routeTo.params.walletAddress = walletAddress
          return next()
        }

        const report = store.getters['report/getReportByAddressWallet'](
          walletAddress
        )

        if (report) {
          if (!store.getters['report/currentReport']) {
            await store.dispatch('report/selectReport', report)
          }
          routeTo.params.walletAddress = walletAddress
          // Continue to the route.
          return next()
        }

        return next({ name: '404', params: { resource: 'addressWallet' } })
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/new-verification',
    name: 'new-verification',
    component: () => lazyLoadView(/* webpackChunkName: "new-verifications" */import('@views/new-verification.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/buy-credits',
    name: 'buy-credits',
    component: () => lazyLoadView(import(/* webpackChunkName: "buy-credits" */'@views/buy-credits.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/404',
    name: '404',
    component: () => {
      return store.getters['auth/loggedIn']
      ? lazyLoadView(import(/* webpackChunkName: "_404" */'@views/_404.vue'))
      : lazyLoadView(import(/* webpackChunkName: "_404-not-logged" */'@views/_404-not-logged.vue'))
    },
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/',
    redirect: 'dashboard',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//

function lazyLoadView (AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@components/loader-fullscreen.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 100,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 5000,
  })

  return Promise.resolve({
    functional: true,
    render (h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
